import { createUseStyles, ComposedTheme } from '@glu/theming';

export const styles = ({
  grid: {
    separator: { color },
  },
}: ComposedTheme) => ({
  auxWrap: {
    lineHeight: '24px',
    borderLeft: `2px solid ${color}`,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 8,
    marginLeft: 8,
  },
});

export default createUseStyles(styles);
